module.exports = __webpack_public_path__ + "img/classification.17fa93ec.svg";